
    import Vue from 'vue';
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import VueQrCode from "@chenfengyuan/vue-qrcode";

    Vue.component(VueQrCode.name, VueQrCode);

    @Component({
        components: {
            VueQrCode
        }
    })
    export default class QrCode extends Vue{
        @Prop({ required: true })
        value!: string;
        
        getBase64QrCode(): string {
            return (this.$el as HTMLImageElement).src;
        }
    }
